import store from "@/store";
import Axios from "axios";
export default () => {
  var client = Axios.create({
    baseURL: "/",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
  client.defaults.timeout = 30000;
  client.defaults.paramsSerializer = {
    indexes: null,
  };
  client.interceptors.request.use(
    (config) => {
      const token = store.state.token != null ? store.state.token.access_token : null;
      const connectionId = store.state.NotificationStore.connectionId != null ? store.state.NotificationStore.connectionId : null;
      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      }
      if (connectionId) {
        config.headers["connectionId"] = connectionId;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  client.interceptors.response.use(
    (response) => {
      if (response.status === 200 || response.status === 201) {
        var meta = response.config.meta;
        if (meta && meta.successText) {
          var snackbarmethod;
          switch (response.config.method) {
            case "put":
              snackbarmethod = 'simpleCreateSuccess'
              break;
            case "post":
            case "patch":
              snackbarmethod = 'simpleChangeSuccess'
              break;
            case "delete":
              snackbarmethod = 'simpleDeleteSuccess'
              break;
            default:
              snackbarmethod = 'responseSnackbar'
          }
          store.dispatch('triggerevents/' + snackbarmethod, meta.successText);
        }
        return Promise.resolve(response);
      } else {
        return Promise.reject(response);
      }
    },
    async (error) => {
      const originalRequest = error.config;
      //if request was canceled, do not show error
      if (error.code == 'ERR_CANCELED') { 
        return Promise.reject(error);
      }

      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const data = await refreshToken();
          store.dispatch("updateToken", data);
          originalRequest.headers["Authorization"] = 'Bearer ' + data.access_token;
          var newRequest = Axios(originalRequest);
          return Promise.resolve(newRequest);
        }
        catch (error) {
          store.dispatch("logout");
        }
      }
      else if (error.response.status == 401) {
        store.dispatch("logout");
      }
      var meta = error.response.config.meta;
      if (meta) {
        store.dispatch('triggerevents/responseSnackbar', {
          response: error.response,
          method: meta?.clientApiMethod,
          text: meta?.onErrorMessage ? meta.onErrorMessage(error) : error.response.data.StatusCode != 500 ? error.response.data.Message : "Unexpected error. Contact support.",
          input: meta?.input,
          color: meta?.color ?? error.response.data.StatusCode != 500 ? "warning" : null,
          icon: meta?.icon ?? error.response.data.StatusCode != 500 ? "mdi-information-outline" : null,
          noClutter: meta?.noClutter ?? false,
        });
      }
      return Promise.reject(error.response);
    }
  );
  return client;
};
async function refreshToken() {
  const token = store.state.token != null ? store.state.token.refresh_token : null;
  var refreshTokenClient = Axios.create({
    baseURL: "/",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Authorization": "Bearer " + token
    },
  });
  var response = await refreshTokenClient.post("/api2/token/refresh");
  return response.data;
}